export const environment = {
  production: false,
  API_BASE_URL: 'https://api-internal.netlify.app/api/',
  ENCRYPTION_KEY: 'kfNQxCtY7U8dYI7BhViM8zAbkElxA2g3rKHqSb9ZKLo=',
  APP_VERSION: 'CRM',
  TRACKING_MAP_BASE_URL: 'https://dcs-tracking-test.netlify.app/#/map',
  performanceWeights: {
    containers: 0.45,    // Peso dei container movimentati: 45% (priorità massima)
    jobs: 0.20,           // Peso delle pratiche/jobs: 20% (efficienza operativa)
    customers: 0.20,     // Peso dei clienti attivi: 20% (base clienti)
    events: 0.10,        // Peso delle attività sales: 10% (sviluppo commerciale)
    quotations: 0.05     // Peso delle quotazioni emesse: 5% (pipeline commerciale)
  },
};
